import { useEffect } from "react";
export default function Header() {
  useEffect(() => {
    // Mobile menu toggle
    const btn = document.getElementById('pda-hamburger');
    const menu = document.getElementById('pda-mobile-menu');
    if (btn && menu) {
      const toggle = () => {
        const isOpen = menu.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(isOpen));
      };
      btn.addEventListener('click', toggle);
    }

    // WooCommerce cart count badge
    const updateCartCount = () => {
      fetch('/wp-json/wc/store/v1/cart', {
        credentials: 'include'
      }).then(r => r.json()).then(data => {
        const count = data.items_count || 0;
        document.querySelectorAll('.pda-cart-badge').forEach(badge => {
          if (badge instanceof HTMLElement) {
            badge.textContent = String(count);
            badge.style.setProperty('display', count > 0 ? 'flex' : 'none', 'important');
          }
        });
      }).catch(() => {});
    };
    updateCartCount();
    return () => {
      if (btn) btn.replaceWith(btn.cloneNode(true));
    };
  }, []);
  const headerContent = `<style>
  #pda-site-header {
    position: sticky !important;
    top: 0 !important;
    z-index: 999 !important;
    background: rgba(248,245,242,.95) !important;
    backdrop-filter: blur(16px) !important;
    -webkit-backdrop-filter: blur(16px) !important;
    border-bottom: 1px solid #c7d1c7 !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
  #pda-site-header * {
    box-sizing: border-box !important;
    font-family: "Greycliff CF", Inter, ui-sans-serif, system-ui, sans-serif !important;
    -webkit-font-smoothing: antialiased !important;
  }
  .pda-nav-wrap {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 20px !important;
    min-height: 70px !important;
    width: min(1180px, calc(100% - 40px)) !important;
    margin-inline: auto !important;
  }
  .pda-nav-wrap .pda-brand      { order: 1 !important; }
  .pda-nav-wrap .pda-nav-links  { order: 2 !important; }
  .pda-nav-wrap .pda-nav-right  { order: 3 !important; }
    .pda-brand {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    font-weight: 900 !important;
    font-size: 17px !important;
    letter-spacing: -.01em !important;
    color: #152937 !important;
    text-decoration: none !important;
    flex-shrink: 0 !important;
    background: transparent !important;
    background-color: transparent !important;
  }
   .pda-brand img {
    height: 64px !important; width: auto !important;
    max-width: 180px !important;
    display: block !important;
    background: transparent !important;
    background-color: transparent !important;
  }
  .pda-brand-name { color: #152937 !important; font-weight: 900 !important; font-size: 17px !important; }
  .pda-nav-links {
    display: flex !important; align-items: center !important;
    gap: 2px !important; list-style: none !important; margin: 0 !important; padding: 0 !important;
  }
  .pda-nav-links > a, .pda-has-dropdown > a {
    display: inline-flex !important; align-items: center !important; gap: 4px !important;
    padding: 8px 14px !important; border-radius: 999px !important; font-weight: 700 !important;
    font-size: 14.5px !important; color: #475c6b !important; text-decoration: none !important;
    transition: color .15s, background .15s !important; white-space: nowrap !important;
    cursor: pointer !important; border: none !important; background: transparent !important;
  }
  .pda-nav-links > a:hover, .pda-has-dropdown > a:hover {
    color: #152937 !important; background: #e8eee8 !important;
  }
  .pda-drop-arrow { font-size: 10px !important; opacity: .55 !important; color: #475c6b !important; }
  .pda-has-dropdown { position: relative !important; }
  .pda-dropdown {
    display: none !important; position: absolute !important;
    top: calc(100% + 8px) !important; left: 0 !important;
    min-width: 210px !important; background: #fbfaf8 !important;
    border: 1px solid #c7d1c7 !important; border-radius: 16px !important;
    box-shadow: 0px 8px 20px rgba(14,27,37,.14) !important;
    padding: 6px !important; z-index: 300 !important;
  }
  .pda-has-dropdown:hover .pda-dropdown { display: block !important; }
  .pda-dropdown a {
    display: block !important; padding: 9px 13px !important; border-radius: 10px !important;
    font-size: 14px !important; font-weight: 600 !important; color: #12212b !important;
    text-decoration: none !important; white-space: nowrap !important;
  }
  .pda-dropdown a:hover { background: #e8eee8 !important; color: #152937 !important; }
  .pda-dropdown-divider {
    height: 1px !important; background: #c7d1c7 !important;
    margin: 4px 8px !important; border: none !important;
  }
  .pda-nav-right {
    display: flex !important; align-items: center !important;
    gap: 12px !important; flex-shrink: 0 !important;
  }
  .pda-cart {
    position: relative !important;
    display: inline-flex !important; align-items: center !important;
    justify-content: center !important; gap: 6px !important;
    padding: 8px 14px !important;
    border-radius: 999px !important;
    color: #475c6b !important; text-decoration: none !important;
    font-weight: 700 !important; font-size: 14.5px !important;
    transition: color .15s, background .15s !important; flex-shrink: 0 !important;
    white-space: nowrap !important;
  }
  .pda-cart:hover { color: #152937 !important; background: #e8eee8 !important; }
  .pda-cart svg { display: block !important; flex-shrink: 0 !important; }
  .pda-cart-text { color: inherit !important; }
  .pda-cart-badge {
    display: none !important;
    min-width: 18px !important; height: 18px !important;
    background: #d2562d !important;
    color: #fff !important;
    border-radius: 999px !important;
    font-size: 10px !important; font-weight: 900 !important;
    align-items: center !important; justify-content: center !important;
    line-height: 1 !important; padding: 0 4px !important;
    pointer-events: none !important;
  }
  .pda-nav-cta {
    display: inline-flex !important; align-items: center !important;
    justify-content: center !important; padding: 10px 20px !important;
    border-radius: 999px !important; background: #d2562d !important;
    color: #fbfaf8 !important; font-weight: 800 !important; font-size: 14px !important;
    text-decoration: none !important; border: none !important; cursor: pointer !important;
    box-shadow: 0 6px 16px rgba(210,86,45,.22) !important;
    transition: opacity .18s, transform .18s !important; white-space: nowrap !important;
  }
  .pda-nav-cta:hover { opacity: .88 !important; transform: translateY(-1px) !important; color: #fbfaf8 !important; }
  .pda-hamburger {
    display: none !important; flex-direction: column !important; gap: 5px !important;
    background: transparent !important; border: none !important;
    padding: 8px !important; cursor: pointer !important; border-radius: 8px !important;
  }
  .pda-hamburger span {
    display: block !important; width: 22px !important; height: 2px !important;
    background: #152937 !important; border-radius: 2px !important;
  }
  .pda-hamburger:hover { background: #e8eee8 !important; }
  #pda-mobile-menu {
    display: none !important; border-top: 1px solid #c7d1c7 !important;
    background: #f8f5f2 !important; padding: 16px 20px 20px !important;
  }
  #pda-mobile-menu.open { display: block !important; }
  #pda-mobile-menu nav {
    display: flex !important; flex-direction: column !important;
    gap: 4px !important; margin-bottom: 16px !important;
  }
  #pda-mobile-menu nav a {
    padding: 12px 16px !important; border-radius: 10px !important;
    font-weight: 700 !important; font-size: 15px !important;
    color: #152937 !important; text-decoration: none !important;
  }
  #pda-mobile-menu nav a:hover { background: #e8eee8 !important; }
  #pda-mobile-menu .pda-mobile-sub {
    padding-left: 16px !important; border-left: 2px solid #c7d1c7 !important; margin: 4px 0 4px 16px !important;
  }
  #pda-mobile-menu .pda-mobile-sub a {
    font-size: 14px !important; font-weight: 600 !important; color: #475c6b !important; padding: 9px 12px !important;
  }
  #pda-mobile-menu .pda-nav-cta { width: 100% !important; justify-content: center !important; margin-top: 8px !important; }
  @media (max-width: 768px) {
    .pda-nav-links { display: none !important; }
    .pda-hamburger { display: flex !important; }
    .pda-brand-name { display: none !important; }
  }
  @media (max-width: 400px) {
    .pda-nav-wrap { width: calc(100% - 28px) !important; }
  }
</style>

<header id="pda-site-header">
  <div class="pda-nav-wrap">

    <a class="pda-brand" href="https://pdaaustralia.com.au/" aria-label="PDA Australia home">
      <img src="https://pdaaustralia.com.au/wp-content/uploads/2026/06/PDA_Australia_logo_transparent.png"
           alt="PDA Australia logo"
           onerror="this.style.display='none'">
    </a>

    <nav class="pda-nav-links" aria-label="Primary navigation">
      <a href="https://pdaaustralia.com.au/articles/">Articles</a>
      <div class="pda-has-dropdown">
        <a href="https://pdaaustralia.com.au/resources/">Free Resources <span class="pda-drop-arrow">&#9662;</span></a>
        <div class="pda-dropdown" role="menu">
          <a href="https://pdaaustralia.com.au/ndis/">NDIS &amp; PDA</a>
          <a href="https://pdaaustralia.com.au/schools/">PDA at School</a>
          <a href="https://pdaaustralia.com.au/adults/">PDA in Adults</a>
          <a href="https://pdaaustralia.com.au/girls/">Girls &amp; Women</a>
          <a href="https://pdaaustralia.com.au/support/">Support &amp; Services</a>
          <hr class="pda-dropdown-divider">
          <a href="https://pdaaustralia.com.au/resources/">Resources Library</a>
        </div>
      </div>
      <a href="https://pdaaustralia.com.au/start-here/">Start Here</a>
    </nav>

    <div class="pda-nav-right">
      <a class="pda-cart" href="https://pdaaustralia.com.au/cart/" aria-label="View cart">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        <span class="pda-cart-text">Cart</span>
        <span class="pda-cart-badge" aria-label="items in cart">0</span>
      </a>
      <a class="pda-nav-cta" href="https://pdaaustralia.com.au/product/funded-ndis-guide-pda/">NDIS Funding Guide</a>
      <button id="pda-hamburger" class="pda-hamburger" aria-label="Toggle navigation" aria-expanded="false">
        <span></span><span></span><span></span>
      </button>
    </div>

  </div>

  <div id="pda-mobile-menu" aria-label="Mobile navigation">
    <nav>
      <a href="https://pdaaustralia.com.au/articles/">Articles</a>
      <a href="https://pdaaustralia.com.au/resources/">Free Resources</a>
      <div class="pda-mobile-sub">
        <a href="https://pdaaustralia.com.au/ndis/">NDIS &amp; PDA</a>
        <a href="https://pdaaustralia.com.au/schools/">PDA at School</a>
        <a href="https://pdaaustralia.com.au/adults/">PDA in Adults</a>
        <a href="https://pdaaustralia.com.au/girls/">Girls &amp; Women</a>
        <a href="https://pdaaustralia.com.au/support/">Support &amp; Services</a>
      </div>
      <a href="https://pdaaustralia.com.au/start-here/">Start Here</a>
    </nav>
    <a class="pda-cart" href="https://pdaaustralia.com.au/cart/" aria-label="View cart">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
      <span class="pda-cart-text">Cart</span>
      <span class="pda-cart-badge" aria-label="items in cart">0</span>
    </a>
    <a class="pda-nav-cta" href="https://pdaaustralia.com.au/product/funded-ndis-guide-pda/">NDIS Funding Guide</a>
  </div>
</header>`;
  return <div dangerouslySetInnerHTML={{
    __html: headerContent
  }} />;
}